import { FilterOperator, useDataSourceListQuery } from '@kinetic-ui/data-layer';
import { getNodes } from 'kineticUtils';
import { useCallback, useMemo } from 'react';

const usePointLocationTypes = () => {
  const { data, loading } = useDataSourceListQuery({
    variables: {
      sourceId: 'locationType',
      filters: {
        field: 'attributes.GEOMETRY_TYPE',
        operator: FilterOperator.Equals,
        value: 'POINT',
      },
    },
  });

  const geometricConfigLocationTypes = useMemo(
    () => getNodes(data?.dataSources)?.map((source) => source.value) || [],
    [data]
  );

  return { geometricConfigLocationTypes, loading };
};

export const useIsLocationTypePoint = (locationType?: string) => {
  const { geometricConfigLocationTypes, loading } = usePointLocationTypes();

  const getIsLocationTypePoint = useCallback(
    (type?: string) => {
      if (!type) {
        return false;
      }
      return geometricConfigLocationTypes.includes(type);
    },
    [geometricConfigLocationTypes]
  );

  const isLocationTypePoint = useMemo(
    () => getIsLocationTypePoint(locationType),
    [locationType, getIsLocationTypePoint]
  );

  return { isLocationTypePoint, getIsLocationTypePoint, loading };
};
